import moment from "moment";

function countdown(time) {
  const diff = new Date(time).getTime() - new Date().getTime();
  const seconds = Math.floor(diff / 1000);

  const prefix = seconds >= 0 ? "" : "-";
  const adjSeconds = Math.abs(seconds);

  if (adjSeconds > 0 && adjSeconds > 3600) {
    return moment(time).format("LT");
  }

  if (adjSeconds > 3600) {
    return `${prefix}${Math.floor(adjSeconds / 60)}m`;
  }

  if (adjSeconds > 600) {
    return `${prefix}${Math.floor(adjSeconds / 60)}m`;
  }

  if (adjSeconds >= 60) {
    return `${prefix}${Math.floor(adjSeconds / 60)}m ${adjSeconds % 60}s`;
  }

  if (adjSeconds >= 0) {
    return `${prefix}${adjSeconds % 60}s`;
  }

  return moment(time).format("LT");
}

function isLikelyUnixTimestamp(time) {
  const parsed = parseInt(time, 10);

  // start of 2020 to end of 2030
  if (!Number.isInteger(parsed)) return false;

  const isSecondsTimestamp = parsed > 1577800800 && parsed < 1893420000;
  if (isSecondsTimestamp) return true;

  const isMillisecondsTimestamp =
    parsed > 1577800800000 && parsed < 1893420000000;

  return isMillisecondsTimestamp;
}

export { countdown, isLikelyUnixTimestamp };
